import isNil from 'lodash/isNil';

// Compare specified properties on two objects.
// Properties can be specified as paths with dot syntax e.g. ('kunde.kundeId') in order to drill down
// into an object hierarchy.
// Option 'allowNil' defines property equality to allow null or undefined. Otherwise, missing properties are considered to be not matching.
export const compareProps = (props: string[], a, b, allowNil = false): boolean => {
  return (
    a === b ||
    (props
      ? props.every(prop => {
        return comparePath(prop.split('.'), a, b, allowNil);
      })
      : false)
  );
};

function comparePath(path: string[], a, b, allowNil = false): boolean {
  if (a === b) {
    return true;
  }

  // If items not equal and either of the items are not objects, return false.
  if (a === null || b === null || typeof a !== 'object' || typeof b !== 'object') {
    return false;
  }

  if (path.length > 1) {
    return comparePath(path.slice(1), a[path[0]], b[path[0]], allowNil);
  }

  // check whether prop is unavailable on any object
  if (!allowNil && (isNil(a[path[0]]) || isNil(b[path[0]]))) {
    return false;
  }

  return a[path[0]] === b[path[0]];
}
